import { useLocale } from 'state/intl';
import { PROD_SUPPORTED_REGIONS, regionSupportedLanguages } from 'state/intl/constants';
/**
 * Localization should be enable depending on languages / regions available
 * @returns boolean
 */
export const useIsLocalizationEnabled = (): boolean => {
  const { region } = useLocale();
  const hasMultipleRegions: boolean = Object.keys(PROD_SUPPORTED_REGIONS).length > 1;
  const hasMultipleLanguagesForRegion = region && regionSupportedLanguages[region]?.size > 1;

  return hasMultipleRegions || hasMultipleLanguagesForRegion;
};
